import { GET_GIFS, GET_GIFS_SEARCH, GIF_ERROR } from '../actions/types';

const initialState = {
  gifs: [],
  loading: true,
  error: {}
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_GIFS:
    case GET_GIFS_SEARCH:
      return {
        ...state,
        gifs: payload,
        loading: false
      };
    case GIF_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
